import React, { useEffect, useMemo, useRef, useState } from "react";
import { firestore } from "../../utils/firebase";
import { Link, useHistory } from "react-router-dom";
import { FiAlertCircle, FiArrowLeft, FiArrowUpRight, FiCalendar, FiClock, FiPhoneCall, FiRefreshCw, FiUsers } from "react-icons/fi";
import "./SonAramalar.css";

const today = () => new Date().toISOString().slice(0, 10);

const formatCallDate = (timestamp) => {
  if (!timestamp) return "—";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("tr-TR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

const getOrderTotal = (item) => (item.cart || []).reduce((total, cartItem) => total + (Number(cartItem.total) || 0), 0);

const SonAramalar = () => {
  const history = useHistory();
  const cafe = localStorage.getItem("name");
  const [page, setPage] = useState(1);
  const [startDate, setStartDate] = useState(today());
  const [endDate, setEndDate] = useState(today());
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const pageCursors = useRef({});

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);
    let query = firestore.collection(`Restaurants/${cafe}/aramalar`)
      .where("tarih", ">=", new Date(new Date(startDate).setHours(0, 0, 0, 0)))
      .where("tarih", "<=", new Date(new Date(endDate).setHours(23, 59, 59, 999)))
      .orderBy("tarih")
      .limit(20)
    if (pageCursors.current[page]) query = query.startAfter(pageCursors.current[page]);
    query.get()
      .then((snapshot) => {
        if (!active) return;
        if (snapshot.docs.length === 20) pageCursors.current[page + 1] = snapshot.docs[snapshot.docs.length - 1];
        setItems(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setLoading(false);
      })
      .catch((requestError) => {
        if (!active) return;
        setError(requestError);
        setItems([]);
        setLoading(false);
      });
    return () => { active = false; };
  }, [cafe, page, startDate, endDate]);

  const uniqueNumbers = useMemo(() => new Set(items.map((item) => item.numara)).size, [items]);
  const totalAmount = useMemo(() => items.reduce((total, item) => total + getOrderTotal(item), 0), [items]);
  const changeStartDate = (value) => { pageCursors.current = {}; setPage(1); setStartDate(value); };
  const changeEndDate = (value) => { pageCursors.current = {}; setPage(1); setEndDate(value); };
  const clearDates = () => { pageCursors.current = {}; setPage(1); setStartDate(today()); setEndDate(today()); };

  return (
    <div className="recent-calls-page"><div className="recent-calls-shell">
      <header className="recent-calls-header">
        <button className="recent-calls-back" type="button" onClick={() => history.push("/admin")} aria-label="Geri dön"><FiArrowLeft /></button>
        <div className="recent-calls-heading"><span className="recent-calls-eyebrow">SİPARİŞ YÖNETİMİ / TELEFON</span><h1>Son aramalar</h1><p>Telefonla gelen müşterileri geçmiş aramalardan hızlıca tekrar siparişe yönlendir.</p></div>
        <div className="recent-calls-header-icon"><FiPhoneCall /></div>
      </header>

      <section className="recent-calls-stats">
        <div className="recent-calls-stat"><span className="recent-calls-stat-icon blue"><FiPhoneCall /></span><div><small>ARALIKTAKİ ARAMA</small><strong>{items.length}</strong><span>Sonuç listesi</span></div></div>
        <div className="recent-calls-stat"><span className="recent-calls-stat-icon violet"><FiUsers /></span><div><small>FARKLI NUMARA</small><strong>{uniqueNumbers}</strong><span>Tekil müşteri</span></div></div>
        <div className="recent-calls-stat recent-calls-stat--accent"><div><small>GÖRÜNEN SİPARİŞ TOPLAMI</small><strong>{totalAmount.toFixed(2)} TL</strong><span>Sepet toplamlarından</span></div></div>
      </section>

      <section className="recent-calls-panel">
        <div className="recent-calls-panel-heading"><div><span className="recent-calls-kicker">ARAMA GEÇMİŞİ</span><h2>Telefon kayıtları</h2></div><span className="recent-calls-count">Sayfa {page}</span></div>
        <div className="recent-calls-toolbar"><div className="recent-calls-date-field"><FiCalendar /><label>Başlangıç<input type="date" value={startDate} max={endDate} onChange={(event) => changeStartDate(event.target.value)} /></label></div><span className="recent-calls-date-separator">—</span><div className="recent-calls-date-field"><FiCalendar /><label>Bitiş<input type="date" value={endDate} min={startDate} onChange={(event) => changeEndDate(event.target.value)} /></label></div><button className="recent-calls-reset" type="button" onClick={clearDates}><FiRefreshCw /> Bugün</button></div>

        {loading ? <div className="recent-calls-state"><span className="recent-calls-spinner"><FiRefreshCw /></span><strong>Aramalar yükleniyor</strong><span>Seçtiğin tarih aralığı kontrol ediliyor.</span></div> : error ? <div className="recent-calls-state recent-calls-state--error"><FiAlertCircle /><strong>Aramalar yüklenemedi</strong><span>{error.message || "Tarih aralığını veya bağlantını kontrol edip tekrar dene."}</span></div> : items.length === 0 ? <div className="recent-calls-state"><FiPhoneCall /><strong>Bu aralıkta arama yok</strong><span>Farklı bir tarih aralığı seçerek tekrar deneyebilirsin.</span></div> : <div className="recent-calls-table-wrap"><table className="recent-calls-table"><thead><tr><th>Arama zamanı</th><th>Telefon numarası</th><th>Sepet toplamı</th><th className="recent-calls-action-column">Aksiyon</th></tr></thead><tbody>{items.map((item, index) => <tr key={item.id || `${item.numara}-${index}`}><td><span className="recent-calls-time"><FiClock />{formatCallDate(item.tarih)}</span></td><td><span className="recent-calls-number"><span>{String(item.numara || "—").slice(-2)}</span><strong>{item.numara || "Numara yok"}</strong></span></td><td><strong className="recent-calls-amount">{getOrderTotal(item).toFixed(2)} TL</strong></td><td className="recent-calls-action-column"><Link className="recent-calls-order-button" to={`/admin/arama-tekrar/${item.numara}`}>Sipariş al <FiArrowUpRight /></Link></td></tr>)}</tbody></table></div>}

        {!loading && !error && items.length > 0 && <div className="recent-calls-footer"><span><strong>{items.length}</strong> kayıt gösteriliyor</span><div className="recent-calls-pagination"><button type="button" onClick={() => setPage(1)} disabled={page === 1}>İlk</button><button type="button" onClick={() => setPage(page - 1)} disabled={page === 1}>Önceki</button><span>{page}</span><button type="button" onClick={() => setPage(page + 1)} disabled={items.length < 20}>Sonraki</button></div></div>}
      </section>
    </div></div>
  );
};

export default SonAramalar;
